/* Стили прототипа без изменений, в том же порядке, что в его HTML: base-trainer → theme → pages.
   pages.css в прототипе НЕ подключён на странице конструктора (constructor.html) — в SPA все стили
   глобальные, поэтому pages.css включается отдельным тегом и отключается на маршруте конструктора
   (иначе, например, его `.empty{padding:36px}` ломает пустое поле нагрузки). */
import './base-trainer.css';
import './theme-01-strava.css';
/* Дополнения кабинета (вход, анкета) — не пересекаются с pages.css */
import './extra.css';
import pagesCss from './pages.css?inline';
/* Мобильная версия (≤ 760 px) — mobile.css прототипа без изменений, плюс поправки под отличия кабинета
   от прототипа (mobile-app.css). Прототип подключает mobile.css последним — он перебивает остальные
   стили при равной специфичности; pages.css вставляется тегом позже импортов, поэтому мобильные
   стили тоже живут отдельным тегом, и pages.css встаёт перед ним. */
import mobileCss from './mobile.css?inline';
import mobileAppCss from './mobile-app.css?inline';
import { useEffect } from 'react';

const mobileTag = document.createElement('style');
mobileTag.dataset.src = 'mobile.css';
mobileTag.textContent = mobileCss + '\n' + mobileAppCss;
document.head.appendChild(mobileTag);

let tag: HTMLStyleElement | null = null;
export function setPagesCss(on: boolean) {
  if (!tag) {
    tag = document.createElement('style');
    tag.dataset.src = 'pages.css';
    tag.textContent = pagesCss;
  }
  if (on && !tag.isConnected) document.head.insertBefore(tag, mobileTag);
  if (!on && tag.isConnected) tag.remove();
}
/** В компоненте страницы: usePagesCss(false) — для конструктора, по умолчанию включён */
export function usePagesCss(on = true) {
  useEffect(() => {
    setPagesCss(on);
    return () => setPagesCss(true);
  }, [on]);
}
setPagesCss(true);
